import { P } from '@/components/Atoms/P/P';
import { H2 } from '@/components/Core/Heading';
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import { Stack } from '@/components/Molecules/Stack/Stack';
import classNames from '@/utils/classNames';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';
import type { FCh } from 'react-fc';
import styles from './SectionRowsTemplate.module.css';

interface SectionRowsContainerProps extends HTMLAttributes<HTMLDivElement> {
    $inverseStripes?: boolean;
}

export const SectionRowsContainer: FCh<SectionRowsContainerProps> = ({
    $inverseStripes,
    className,
    children,
    ...rest
}) => (
    <div
        className={classNames(
            {
                [styles.sectionRowsContainerInverseStripes]: $inverseStripes,
                [styles.sectionRowsContainer]: !$inverseStripes,
            },
            className
        )}
        {...rest}
    >
        {children}
    </div>
);

export const SectionsRowsItem: FCh<{ id?: string } & HTMLAttributes<HTMLDivElement>> = ({
    id,
    children,
    className,
    ...rest
}) => (
    <section id={id} className={`${styles.styledSection} ${className ?? ''}`} {...rest}>
        <CenteredPageContent>{children}</CenteredPageContent>
    </section>
);

export const SectionTitle = ({ title, subtitle, more, as = 'h2', className, ...rest }: ISectionTitleProps) => (
    <Stack $gap="var(--size-grid-half)" className={classNames(styles.container, className)} {...rest}>
        <div className={styles.titleLine}>
            <H2 as={as}>{title}</H2>
            {more && <a href={more.url}>{more.text}</a>}
        </div>
        {subtitle && <P>{subtitle}</P>}
    </Stack>
);

export interface ISectionTitleProps extends HTMLAttributes<HTMLDivElement> {
    as?: ElementType;
    title: string;
    subtitle?: string;
    more?: { text: ReactNode; url: string };
}
